import React, { useMemo } from 'react'
import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@material-ui/core'
import moment from 'moment'
import formatCurrency from '../../../utils/formatCurrency'

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    borderRadius: 8,
    overflow: 'hidden',
    marginTop: 10,
    marginBottom: 40,
  },
  headCell: {
    backgroundColor: '#635BFF',
    color: '#fff',
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 14,
  },
  bodyCell: {
    backgroundColor: '#d0ccff',
    textAlign: 'center',
    fontWeight: 'bold',
    padding: 14,
  },
  highlightedCell: {
    backgroundColor: '#88D77C',
    textAlign: 'center',
    fontWeight: 'bold',
  },
})

const SummaryFinancialsTable = ({
  monthlyWipReports,
  invoiceTotals,
  pacing,
  currency,
  showCurrentMonthValue,
  wipReport,
}) => {
  const classes = useStyles()

  const currentMonth = moment().startOf('month')

  const budgetMonths = useMemo(() => {
    let bugdetsMontly = []
    try {
      bugdetsMontly =
        monthlyWipReports
          ?.filter(item => moment(item.month, 'YYYY-MM').isAfter(currentMonth))
          .slice(0, 2) || []
    } catch (error) {
      console.warn('Error handling wip report months')
      console.log(error)
      console.log(monthlyWipReports)
    }

    return bugdetsMontly
  }, [monthlyWipReports])

  return (
    <TableContainer component={Paper} className={classes.table} data-testid="wip.summaryFinancials">
      <Table>
        <TableHead>
          <TableRow>
            {/* Current month pacing */}
            <TableCell className={classes.headCell}>
              {moment(currentMonth).format('MMMM')}
            </TableCell>
            {/* Future months budget */}
            {budgetMonths.map(report => {
              const displayName = moment(report.month, 'YYYY-MM').format('MMMM')

              return (
                <TableCell key={report.month} className={classes.headCell}>
                  {displayName}
                </TableCell>
              )
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            {/* Current month pacing */}
            <TableCell className={classes.highlightedCell}>
              {showCurrentMonthValue
                ? formatCurrency(wipReport.submittedHours.staffRate, currency)
                : 'Current'}
            </TableCell>
            {/* Future months budget */}
            {budgetMonths.map(report => {
              return (
                <TableCell key={report.month} className={classes.bodyCell}>
                  {formatCurrency(report.budget, currency)}
                </TableCell>
              )
            })}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default SummaryFinancialsTable
